<template>
  <div class="admin-layout">
    <div class="content">
      <Header/>
      <slot/>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from '@/components/admin/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
  name: 'AdminLayout',
  components: {
    Header,
    Footer
  },
}
</script>
<style>
.admin-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.admin-layout .content {
  flex: 1 0 auto;
}
</style>